import type { TFunction } from 'i18next';

import type { CopyReport } from '@/entities/database';

/** The toast after a copy: its name, and - when it happened - the people left out of it. */
export function duplicatedMessage(t: TFunction, name: string, report: CopyReport): string {
  const base = t('databases.duplicate.done', { name });
  return report.dropped_user_references > 0
    ? `${base} ${t('databases.duplicate.droppedPeople', { count: report.dropped_user_references })}`
    : base;
}
